module.exports = __webpack_public_path__ + "img/13.ed225a0.jpg";